const base_Url = "https://mjludo.in:2701/";
// const base_Url = "http://localhost:2701/";

export default base_Url;
